export enum ResponseErrors {
    TASK_TEMPLATE_NAME_CONFLICT = 'TASK_TEMPLATE_NAME_CONFLICT',
}

export interface ErrorPayload {
    message: string
    status: string
    timestamp: string
    httpStatus: number
    errors: ResponseErrors[]
    [key: string]: unknown
}

export class ResponseError extends Error {
    public handled = false
    public status: number
    public code?: string

    constructor(
        public originalResponse: Response,
        public errorPayload?: ErrorPayload,
    ) {
        super(
            errorPayload?.message || originalResponse.statusText || String(originalResponse.status),
        )
        this.name = 'ResponseError'
        this.status = originalResponse.status
        this.code = errorPayload?.status
    }
}

export function isResponseError(arg: any): arg is ResponseError {
    return arg?.name === 'ResponseError'
}
